const UpdatableRegionProps = [
    "id",
    "start",
    "end",
    "drag",
    "resize",
    "color",
    "content",
    "channelIdx"
];

export { UpdatableRegionProps };
